<template>
  <div id="Student">
    <!-- <UNILORINTop v-show="!this.$store.state.webview" /> -->
    <b-navbar toggleable="lg" type="light" variant="light">
      <b-navbar-brand href="/">
        <img alt="UNILORIN Logo" src="../assets/unilorin-logo.png" height="70" />
      </b-navbar-brand>

      <b-navbar-toggle style="color: #ffffff;" target="nav-collapse" v-show="!this.$store.state.webview"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <li class="nav-item">
            <router-link to="/create" class="nav-link">
              <b-icon-sticky></b-icon-sticky>
              Open New Ticket
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/my-tickets" class="nav-link">
              <b-icon-stickies></b-icon-stickies>
              My Tickets
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/faq" class="nav-link">
              <b-icon-question-circle></b-icon-question-circle>
              FAQs
            </router-link>
          </li>
          <li class="nav-item">
            <router-link to="/login" class="nav-link">
              <b-icon-box-arrow-in-right></b-icon-box-arrow-in-right>
              Login
            </router-link>
          </li>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <!-- <b-navbar-nav class="ml-auto">

        </b-navbar-nav> -->
      </b-collapse>
    </b-navbar>

    <!-- <div style="width: 100%; height: auto; margin-top: 70px;"> -->
    <router-view />
    <!-- </div> -->
  </div>
</template>

<script>
import UNILORINTop from '@/components/UNILORINTop.vue'
export default {
  name: 'StudentLayout',
  components: {
    UNILORINTop
  },
  computed: {
    year() {
      let d = new Date()
      return d.getFullYear()
    }
  }
}
</script>

<style scoped></style>
